// extracted by mini-css-extract-plugin
export default {"textContainer":"TextInput_textContainer__VlsAP","textInput":"TextInput_textInput__w5vxk"};